import { SavingsGoalResponse } from "../services";

export const goalYearOf = (goal: SavingsGoalResponse) =>
  goal.targetDate.slice(0, 4);
